module.exports = __webpack_public_path__ + "img/oufu_91x111x9_5b.prt.b52289c8.jpg";